import createIcon from "../createIcon";
export var MoonConfig = {
  displayName: "Moon",
  attrs: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  css: {
    display: "inline-block",
    verticalAlign: "middle",
    overflow: "hidden",
    maxHeight: "100%",
    maxWidth: "100%",
    margin: "auto"
  },
  width: 24,
  height: 24,
  titleKey: "Moon-title",
  viewBox: "0 0 24 24",
  labelledby: "icon-title-Moon",
  body: [{
    type: "path",
    props: {
      d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z",
      key: "k0"
    }
  }]
};
export default createIcon(MoonConfig);